import { BankingDetails } from '../../../model/banking-details.model';

export type EstimagePayInvoicesPayload = {
  invoices: EstimagePayInvoice[];
  invoiceCount: number;
};

export type EstimagePayInvoice = {
  claimNumber: string;
  rego: string;
  invoiceNumber: string;
  invoiceTotalPayable: number;
  acceptedOrRejectedDateTime: number;
  paymentRequestStatus: PaymentRequestStatus;
  jobId: number;
};

export enum PaymentRequestStatusEnum {
  SUBMITTED = 'SUBMITTED',
  ACTIVE = 'ACTIVE',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED',
  DELETED_AFTER_INVOICE_APPROVAL = 'CANCELLED',
  COMPLETED = 'COMPLETED'
}

export enum PaymentRequestStatusDescriptionEnum {
  ACTIVE = 'Your payment request has been approved, disbursement has been created and will be sent shortly.',
  SUBMITTED = 'Your payment request has been created and is pending manual review.',
  DECLINED = "Your payment request was declined and won't be funded. Please contact Support.",
  CANCELLED = 'Your payment request has been cancelled outside of EstImage by an authorised user.',
  DELETED_AFTER_INVOICE_APPROVAL = 'Your request for payment of this invoice has been cancelled (invoice rejected).',
  COMPLETED = 'Your payment request has been settled.'
}

export type PaymentRequestStatus = keyof typeof PaymentRequestStatusEnum;

export type DisbursementAccount = Partial<BankingDetails> & { accountId: string };

export interface EstImagePayRequest {
  invoiceNumber: string;
  invoiceId: number;
  amountRequested: number;
  accountSelected: Omit<DisbursementAccount, 'accountId'>;
  disbursementAccounts: DisbursementAccount[];
}
